// import "@/styles/themes.scss";
// import "@/styles/layout.scss";
// import "./ResourceGrid.scss";
// import { CleanDescription } from "../../../component/CommonDescription/CommonDescription";
// import { TerraLink } from "../../../component/TerraLink/TerraLink";
import Image from "next/image";
import "./FeaturedCard.css";
import { truncateText } from "@/lib/utils";
import Link from "next/link";
import Icon from "@/components/client/Icon";
import { qualifyImageUrl } from "@/lib/formatImages";

interface FeaturedCardProps {
  image?: any;
  heroImage?: {
    altText: string;
    image: {
      url: string;
    };
  };
  imageType?: "asImage" | "asBackground";
  eyebrow?: string;
  title?: string;
  description?: string;
  slug?: string;
  buttonLabel?: string;

  truncate?: boolean;
  truncateLength?: number;
}
const FeaturedCard = ({
  imageType = "asBackground",
  image,
  heroImage,
  eyebrow,
  title,
  description,
  slug,
  buttonLabel = "Read More",
  truncate,
  truncateLength,
}: FeaturedCardProps) => {

  const imageUrl = image?.url || "";
  const imageUrlStripped = imageUrl.split('?')[0]; // Remove query parameters if any
  const imageUrlReset = qualifyImageUrl(imageUrlStripped, 413, 280) || null // Ensure the image URL is qualified for Next.js Image component

  return (
    <div className="t2-card--featured">
      {imageType !== "asImage" && imageUrlReset && (
        <div
          className="t2-card--featured__image"
          style={{
            backgroundImage: `url(${imageUrlReset})`,
          }}
        ></div>
      )}
      {imageType == "asImage" && imageUrlReset && (
        <Image
          className="t2-card--featured__image--asImage"
          src={imageUrlReset}
          alt={image?.alt || heroImage?.altText || title || ""}
          loading="lazy"
          width={413}
          height={280}
          // title={title}
        />
      )}
      <div className="t2-card--featured__content">
        {eyebrow && <div className="t2-card--featured__eyebrow">{eyebrow}</div>}
        {title && <h3 className="t2-card--featured__header">{title}</h3>}
        {description && truncate && (
          <p className="t2-card--featured__description">
            {truncateText(description, truncateLength)}
          </p>
        )}
        {slug && (
          <Link href={slug} className="t2-terra-text-link">
            {buttonLabel}{" "}
            <Icon
              label="View Post"
              type={"t2u-chevron-right"}
              size={20}
              className="ml-[20px]"
            />
          </Link>
        )}
      </div>
    </div>
  );
};

export default FeaturedCard;
